const ns = {};

ns.DataApplier = function() {};

/**
 * Bindet ein Select-Element zu einem Text-Input. Wird beim Select die
 * Auswahl geändert, wird diese in das Text-Feld übertragen (nur falls value
 * !== '').
 *
 * @param {jQuery} select
 * @param {jQuery} text
 */
ns.DataApplier.prototype.bindSelectToText = function(select, text) {

    $(select).on('change', function(e) {

        var selected = $(this).find('option:selected');

        if (selected.val() !== '') {
            text.val(selected.text());
        }
    });
};

export default ns.DataApplier;
